<ng-container *ngIf="navigationUrl.includes('http'); else noUrl">
  <div class="card-link-external-url-model-header">
    <h1>
      {{ 'fgbcl.card.link.external.url.model.title' | translate }}
    </h1>
  </div>
  <div class="modal-body">
    <div class="app-container">
      <div class="navigation-model-club-image-block">
        <div class="navigation-model-club-image">
          <img class="club-image" [src]="clubImageUrl" />
        </div>
      </div>

      <div class="all-arrows-container">
        <div class="arrows-container">
          <div class="icon material-icons arrow arrow-one left" aria-hidden="true">arrow_forward_ios</div>
          <div class="icon material-icons arrow arrow-two left" aria-hidden="true">arrow_forward_ios</div>
        </div>
        <div class="arrows-container">
          <div class="icon material-icons arrow arrow-one left" aria-hidden="true">arrow_forward_ios</div>
          <div class="icon material-icons arrow arrow-two left" aria-hidden="true">arrow_forward_ios</div>
        </div>
      </div>

      <div class="offer-item">
        <div class="offer-item-image">
          <img class="company-Imge-url" [src]="companyImageUrl | contentImage: '7'" />
        </div>
      </div>
    </div>
  </div>
  <div class="my-4">
    <p class="text-center">
      {{ 'fgbcl.card.link.external.url.model.first.instruction' | translate }}
      <a href="{{ navigationUrl }}" class="click-here"
        ><strong>{{ 'fgbcl.card.link.external.url.model.click.here' | translate }}</strong></a
      >
      {{ 'fgbcl.card.link.external.url.model.second.instruction' | translate }}
    </p>
  </div>
</ng-container>

<ng-template #noUrl>
  <div class="m-4">
    <p class="no-url text-center text-danger font-size-24 fw-bold">
      {{ 'fgbcl.card.link.external.wrong.url.text' | translate }}
    </p>
  </div>
</ng-template>
